"use client"

import React, { useEffect } from "react"
import { Button } from "@heroui/button"
import Link from "next/link"
import s from "./contact.module.css" 
import Map from "~/components/map"
import SocialShare from "~/components/metadata"
import HiddenEmail from "~/components/email-decoder/encode"
import GoogleMaps from "~/components/map/google-maps"

async function getDecoder(...ids) {
    const decode = (await import("~/components/email-decoder")).default;
    decode(...ids);
}

export default function Kontakt() {
    useEffect(() => { getDecoder("mail-1", "mail-2") }, [])

    return (
        <div className={s.wrapper}>
            <>
                <title>Kontakt Oss | Ascendi</title>
                <link rel="canonical" href="https://www.ascendi.no/kontakt/"/>
                <SocialShare/>
            </>
            <div className={s.map}>
                {/* TODO: Fallback to image */}
                {/* TODO: Load from  */}
                <GoogleMaps
                    apiKey="AIzaSyBnea--5mCZY8SjJKiC3KvsoNVFyzaVR6U"
                    options={{
                        mapId: "f73a0521d7153b64", // TODO: use separate IDs for light and dark maps etc.
                        center: { lat: 60.455, lng: 11.100 },
                        zoom: 12.1,
                        mapTypeControl: false,
                        fullscreenControl: false,
                        streetViewControl: false,
                        // TODO: Set styles in Google cloud dashboard now
                    }}
                    markers={[
                        {
                            position: { lat: 60.467959, lng: 11.1717596 },
                            // content: tag
                        }
                    ]}
                    onError={console.error}
                />
            <div className={`bg-card ${s.nav}`}/>
            </div>
            <div className={s.overlay}>
                <div className={`flex flex-col justify-center text-center bg-card h-fit w-fit m-auto md:px-10 px-4 md:py-20 py-8 rounded-lg`}>
                    <h1 className="text-2xl font-bold pb-6">Kontakt Oss</h1>
                    <div className="pb-6">
                        <p className="text-foreground pb-3">
                            Ta kontakt med daglig leder, Lasse Toroczkay, på telefon:
                        </p>
                        <a className="mx-auto text-lg font-semibold" href="tel:+4798082082">98 082 082</a>
                    </div>
                    <div className="pb-6">
                        <p className="text-foreground pb-3">
                            For akutt bistand er vakt telefonen døgnåpen:
                        </p>
                        <a className="mx-auto text-lg font-semibold" href="tel:+4722330100">223 30 100</a>
                    </div>
                    <div className="pb-2">
                    <p>
                        For skriftlig henvendelser send en e-post til <HiddenEmail id="mail-1">sjefen@ascendi.no</HiddenEmail>.
                    </p>
                    </div>
                    <div className="pb-6">
                    <p>
                        For generelle henvendelser send en e-post til <HiddenEmail id="mail-2">hei@ascendi.no</HiddenEmail>.
                    </p>
                    </div>
                    <Button
                        className="my-2 w-full max-w-72 mx-auto bg-[#2540e5] text-white"
                        // color="secondary"
                        size="lg"
                        href="http://maps.apple.com/?daddr=Feiringvegen+949,+2093+Feiring"
                        as={Link}
                    >
                        Åpne i Kart
                    </Button>
                    <p className="text-foreground/60 font-light pt-4">
                        Ascendi AS     org. nr 931 247 778
                    </p>
                </div>
            </div>
        </div>
    )
}